import styled from "styled-components";
import { Dropdown, Form } from "react-bootstrap";

export const RequiredLabel = styled(Form.Label)`
  &::after {
    content: "*";
    color: var(--red);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  }
`;

export const EvaluationTypeContainer = styled.div`
  flex: 1 1 0;
  min-width: 0;
`;

export const EvaluationTypeToggle = styled(Dropdown.Toggle)`
  border-color: var(--input-color) !important;
  overflow: hidden;
`;
